// src/constants/teamSize.js
// New file: Centralizes desired & current team size options.

export const desiredTeamSizeOptions = [
  { value: '2', ar: '٢', en: '2' },
  { value: '3', ar: '٣', en: '3' },
  { value: '4', ar: '٤', en: '4' },
  { value: '+4', ar: 'أكثر من ٤', en: '+4' },
];

export const currentTeamSizeOptions = [
  { value: '1', ar: 'أنا فقط', en: 'Just me' },
  { value: '2', ar: '٢', en: '2' },
  { value: '3', ar: '٣', en: '3' },
];